import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/YourOrders/YourOrders.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

class YourOrders extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            search: "",
            searchlength: 0,
            roleName: "Driver",
            datatemporary: []
        }
        this.handlechangeSearchOrderID = this.handlechangeSearchOrderID.bind(this);
    }
    driverData = [
        { id: 1, containerNo: "MRSU3562332", haulageCompany: "ABC Transport Limited", orderID: "12345", orderDateTime: "29-Oct-2020 16:30", orderStatus: "Open" },
        { id: 2, containerNo: "TLLU5059409", haulageCompany: "ABC Transport Limited", orderID: "12245", orderDateTime: "29-Oct-2020 16:30", orderStatus: "Closed" }
    ];
    respondentData = [
        { id: 1, orderID: "12345", orderDateTime: "29-Oct-2020 12:30", vesselName: "SANTA CLARA", orderStatus: "Open" }
    ];
    componentDidMount = () => {
        if (this.state.roleName === "Driver") {
            this.setState({ data: this.driverData });
        }
        if (this.state.roleName === "Respondent") {
            this.setState({ data: this.respondentData });
        }
    }
    handleContainer = event => {
        this.state.datatemporary.find((dataStorage) => {
            if (dataStorage.id === event + 1) {
                localStorage.setItem("truckBookingNoLS", dataStorage.bookingNo);
                this.props.history.push('/ShipmentDetails', dataStorage.bookingNo)
            }
        })
    }
    handlechangeSearchOrderID = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length
        });
    };
    searchOrder = () => {
        if (this.state.searchlength > 0) {
            const datafilter = this.state.data.filter(i => i.orderID == this.state.search)
            this.setState({ datatemporary: datafilter });
            console.log("inside search function", this.state.datatemporary);
        }
    }
    render() {
        if (this.state.searchlength == 0) {
            this.state.datatemporary = this.state.data;
            console.log("inside render search", this.state.datatemporary);
        }
        return (
            <div class="csOuterColorOrder">
                <MetaDecorator title={TitleDescription.trackMultipleContainerPageTitle} description={TitleDescription.trackMultipleContainerPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csNoFullOrder">
                    <div id="csNoBox1Order">
                        <nav class="ccNoNoNavbarOrder">
                            <div className="ccNoNavbarNameOrder">
                                <small id="noNavcOrder"> Your Orders</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationMainCardOrder">
                            <div class="conCsDivLow199Order">
                                <div class="csDivLow2Pre1Order">
                                    <input
                                        className="preSearchOrder"
                                        placeholder="Search by ID"
                                        autoComplete="off"
                                        id="secrchInput1Pre11Order"
                                        onChange={this.handlechangeSearchOrderID}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchOrder} id="searchPre_Img12Order" src={searchimg} width="16" height="16" />
                                </div>
                            </div>
                            <div class="consDiv1Order">
                                {(this.state.datatemporary.map((datatemporary, index) => {
                                    return (
                                        <div class="outDivInsideOrder" onClick={() => this.handleContainer(index)}>
                                            <div class="secondDivvOrder">
                                                {this.state.roleName === "Driver" ?
                                                    <div class="orderWholeDataDiv">
                                                        <div class="orderContentDiv">
                                                            <small class="orderHeading">Container No.</small>
                                                            <small class="orderValue">{datatemporary.containerNo}</small>
                                                        </div>
                                                        <div class="orderContentDiv">
                                                            <small class="orderHeading">Haulage Company</small>
                                                            <small class="orderValue">{datatemporary.haulageCompany}</small>
                                                        </div>
                                                        <div class="orderContentDiv">
                                                            <small class="orderHeading">Service Request ID</small>
                                                            <small class="orderValue">{datatemporary.orderID}</small>
                                                        </div>
                                                        <div class="orderContentDiv">
                                                            <small class="orderHeading">Service Request Date & Time</small>
                                                            <small class="orderValue">{datatemporary.orderDateTime}</small>
                                                        </div>
                                                        <div class="orderContentDiv">
                                                            <small class="orderHeading">Order Status</small>
                                                            <small class={datatemporary.orderStatus === "Open" ? "orderValueGreen" : "orderValueClosed"}>{datatemporary.orderStatus}</small>
                                                        </div>
                                                        <div class="rightOut1DivOrder">
                                                            <img src={rightarrow} id="rightArrowImgOrder" height="16" width="16" class="" alt="" loading="lazy" />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div class="outerOrderWholeDataDiv">
                                                        {this.state.roleName === "Respondent" ?
                                                            <div class="orderWholeDataDiv">
                                                                <div class="orderContentDiv">
                                                                    <small class="orderHeading">Service Request ID</small>
                                                                    <small class="orderValue">{datatemporary.orderID}</small>
                                                                </div>
                                                                <div class="orderContentDiv">
                                                                    <small class="orderHeading">Service Request Date & Time</small>
                                                                    <small class="orderValue">{datatemporary.orderDateTime}</small>
                                                                </div>
                                                                <div class="orderContentDiv">
                                                                    <small class="orderHeading">Vessel Name</small>
                                                                    <small class="orderValue">{datatemporary.vesselName}</small>
                                                                </div>
                                                                <div class="orderContentDiv">
                                                                    <small class="orderHeading">Order Status</small>
                                                                    <small class={datatemporary.orderStatus === "Open" ? "orderValueGreen" : "orderValueClosed"}>{datatemporary.orderStatus}</small>
                                                                </div>
                                                                <div class="rightOut1DivOrder">
                                                                    <img src={rightarrow} id="rightArrowImgOrder" height="16" width="16" class="" alt="" loading="lazy" />
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>);
                                }))}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01Order">
                    <Footer />
                </div>
                <div class="notifooter02Order">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default YourOrders;